import { createReducer } from 'redux-act';
import { requestSessionDurationData, responseSessionDurationData } from './action';


const defaultState = {
	requestProcess: false,
};

const reducer = createReducer({

	[requestSessionDurationData]: (state) => {
    return {
      requestProcess: true,
	  	data: [],
    };
  },

	[responseSessionDurationData]: (state, params) => {
		return {
			requestProcess: false,
			data: params,
		};
	},


}, defaultState);



export default reducer
